/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Asset type. By default: `supportingDocument`
 */
export type AssetDtoType = (typeof AssetDtoType)[keyof typeof AssetDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssetDtoType = {
  supportingDocument: 'supportingDocument',
  rra: 'rra',
} as const;
